import { render, staticRenderFns } from "./CourseStepForm.vue?vue&type=template&id=13ccf1a1&"
import script from "./CourseStepForm.vue?vue&type=script&lang=js&"
export * from "./CourseStepForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseStepForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports